import { useEffect } from "react";
import { useChatStore } from "@/stores/useChatStore.ts";
import { useAssignedChatStore } from "@/stores/useAssignedChatStore.ts";
import { interventionStorageCollection } from "@/collections/interventionStorageCollection.ts";
import { useInputStore } from "@/stores/useInputStore.ts";
import { useQueryClient } from "@tanstack/react-query";

export const useHookRemoveDeadSessions = () => {
  const { chats } = useChatStore();
  const { RemoveSessionData } = useInputStore();
  const queryClient = useQueryClient();

  // REMOVE DEAD SESSIONS
  useEffect(() => {
    const { activeChat, RemoveChat, UnhookFromChat } = useChatStore.getState();

    // Remove any chat hooks that were opened but never assigned
    chats.forEach((chat) => {
      const { assignedSessions } = useAssignedChatStore.getState();
      const session = assignedSessions.get(chat.flowGeneratorSessionId);
      if (
        session === undefined &&
        activeChat.unwrapOrElse(() => 0) !== chat.flowGeneratorSessionId &&
        (!chat.lastOpened || Date.now() - chat.lastOpened.getTime() > 5 * 60 * 1000)
      ) {
        console.log("Removing unassigned old chat", chat);
        RemoveChat(chat.flowGeneratorSessionId);
        RemoveSessionData(chat.flowGeneratorSessionId);
      }
    });

    chats.forEach((chat) => {
      const { assignedSessions } = useAssignedChatStore.getState();
      const session = assignedSessions.get(chat.flowGeneratorSessionId);

      if (
        session &&
        session.completed &&
        chat.removeHookCallbacks.length > 0 &&
        activeChat.unwrapOrElse(() => 0) !== chat.flowGeneratorSessionId
      ) {
        console.log("Unhooking from completed session", chat);
        UnhookFromChat(chat.flowGeneratorSessionId);
        RemoveSessionData(chat.flowGeneratorSessionId);
      }
    });

    const threeDaysAgo = new Date();
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);

    interventionStorageCollection.forEach((intervention) => {
      if (new Date(intervention.lastInteractedOn) <= threeDaysAgo && !chats.get(intervention.id)) {
        console.log("Deleting stale intervention", intervention.id);
        interventionStorageCollection.delete(intervention.id);
      }
    });
  }, [RemoveSessionData, chats, queryClient]);
};
